<div class="topdiv">
    <label i18n="@@spmsUserReg" class="textColour">Filter Criteria</label>
    <span class="example-spacer"></span>

    <div style="margin-top: 20px;text-align: center; ">
        <form [formGroup]='FormValid'>
             <mat-form-field appearance="outline">
                <mat-label i18n="@@RCFormulaexpression">Enter Filters</mat-label>
                <textarea matInput style="width: 90%; height: 200px;" id="filterquery" placeholder="Enter text here...." formControlName="filterquery" [(ngModel)]="filterquery" minlength="10"  maxlength="1000" required></textarea>            
                 <mat-error *ngFor="let validation of validation_messages.filterquery">
                  <span
                      *ngIf="FormValid.get('filterquery').hasError(validation.type) && (FormValid.get('filterquery').dirty || FormValid.get('filterquery').touched)">
                      {{ validation.message }}
                  </span>
              </mat-error>
              </mat-form-field>
        </form>
    </div>

    <div class="row mb-1 topRowMargins" style= "position:sticky;left:0;bottom:0;width:100%;background-color: #fff;">
        <div class="col-lg text-center">
          <div style="text-align: end; margin-top: 5%;"> 

              <button [disabled]="!FormValid.valid" i18n="@@TMRunButton" type="button" (click)="apply()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding: .3rem 1.6rem;font-size: .85rem;" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Apply</button>


              <button i18n="@@TMRunButton" type="button" (click)="cancel()" class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding: .3rem 1.6rem;font-size: .85rem;" [style.border-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean" >Cancel</button>
            
          </div>
        </div>
      </div> 
</div>